import React, { HTMLAttributes } from 'react'

import { H4 } from '@frame/ui-primitives/h4'
import { P } from '@frame/ui-primitives/p'
import { Span } from '@frame/ui-primitives/span'

import { cn } from '@frame/lib/utils/cn'

type Props = {
  imgSrc?: string
  title?: string
  subTitle?: string
  className?: HTMLAttributes<HTMLHeadingElement>['className']
  bold?: boolean
  descriptionSize?: 'small' | 'default'
  alignTop?: boolean
}

export function CardBulletPoint({
  imgSrc,
  title,
  subTitle,
  className,
  bold = true,
  descriptionSize = 'default',
  alignTop = false,
}: Props) {
  return (
    <div className={cn('flex', alignTop ? 'items-start' : 'items-center')}>
      {imgSrc ? <img src={imgSrc} /> : <Span className="ml-2">{'\u2022'}</Span>}
      <div className="ml-2">
        {title && (
          <H4 className={cn('text-moss-700', !bold && 'font-normal', descriptionSize === 'small' && 'text-sm')}>
            {title}
          </H4>
        )}
        {subTitle && <P className={className}>{subTitle}</P>}
      </div>
    </div>
  )
}
